module.exports = __webpack_public_path__ + "static/media/step2img6.ae2b1b02.JPG";